<template>
  <div class="flex w-full horizontal-tabs">
    <ul class="flex-grow w-1/4 h-full list-none border-r-2 border-gray-100 tab-links">
      <li
        v-for="(tab, index) in tabs"
        :key="index"
        :class="{
          'border-b border-l-4 border-t border-l-green-600 bg-white text-green-600 shadow':
            activeTab === tab.name,
        }"
      >
        <a
          class="block px-4 py-4 cursor-pointer"
          @click="setActiveTab(tab.name)"
        >
          {{ tab.name }}
        </a>
      </li>
    </ul>
    <div class="flex-grow w-3/4 p-8 tab-content">
      <slot :tab="activeTab" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HorizontalTabs',

  emits: ['tabChanged'],

  data() {
    return {
      tabs: [{ name: 'Existing Templates' }, { name: 'Template Builder' }],
      activeTab: 'Existing Templates',
    }
  },
  watch: {
    activeTab: {
      handler(newTab) {
        this.$emit('tabChanged', { tab: newTab })
      },
      immediate: true,
    },
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab
    },
  },
}
</script>
